import React, { FunctionComponent } from 'react';

import { Container } from './styles';

interface Props
  extends React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
  > {
  touched?: string;
  error?: string;
}
const Input: FunctionComponent<Props> = props => (
  <Container>
    <input {...props} />
    {props.error && props.touched === 'true' && (
      <span className="error">{props.error}</span>
    )}
  </Container>
);

export default Input;
